import { useCallback, useMemo } from 'react'
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router'

import { SubMenu } from '../../components/sub-menu'
import { AddAccountPaths } from '../../config/routes'
import { useUser } from '../../contexts/user/user-context'
import { AddBankAccount } from '../add-bank-account'
import { AddCryptoAccount } from '../add-crypto-account'

export function AddAccount() {
    const history = useHistory()
    const location = useLocation()
    const { userProfile }: any = useUser()

    const handlePath = useCallback(
        (path: string) => history.push(path),
        [history],
    )

    const isUSA = useMemo(() => {
        if (!userProfile) return undefined
        return userProfile?.getUserProfile?.country?.abbreviation === 'US'
    }, [userProfile])

    const options = useMemo(() => {
        const bankAccounts = {
            children: 'Bank accounts',
            selected: location.pathname.includes('/bank'),
            onClick: () => handlePath(AddAccountPaths.ADD_BANK_ACCOUNT),
        }

        const cryptoAccounts = {
            children: 'Crypto Accounts',
            selected: location.pathname.includes('/crypto'),
            onClick: () => handlePath(AddAccountPaths.ADD_CRYPTO_ACCOUNT),
        }

        if (isUSA === undefined) return [cryptoAccounts]

        if (!isUSA) {
            if (location.pathname.includes('/bank')) {
                handlePath(AddAccountPaths.ADD_CRYPTO_ACCOUNT)
            }
            return [cryptoAccounts]
        } else {
            return [bankAccounts, cryptoAccounts]
        }
    }, [isUSA, location, handlePath])

    return (
        <div className='container px-12 py-12 mx-auto'>
            <SubMenu options={options} />
            <div className={'my-16 mx-auto w-full'}>
                <Switch>
                    <Route path={AddAccountPaths.ADD_BANK_ACCOUNT}>
                        <AddBankAccount />
                    </Route>
                    <Route path={AddAccountPaths.ADD_CRYPTO_ACCOUNT}>
                        <AddCryptoAccount />
                    </Route>
                    <Route path={AddAccountPaths.ADD_ACCOUNT}>
                        <Redirect to={AddAccountPaths.ADD_CRYPTO_ACCOUNT} />
                    </Route>
                </Switch>
            </div>
        </div>
    )
}
